// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressController from "./address_controller"
application.register("address", AddressController)

import AdminlteController from "./adminlte_controller"
application.register("adminlte", AdminlteController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BootstrapTableController from "./bootstrap_table_controller"
application.register("bootstrap-table", BootstrapTableController)

import CkeditorController from "./ckeditor_controller"
application.register("ckeditor", CkeditorController)

import DaterangepickerController from "./daterangepicker_controller"
application.register("daterangepicker", DaterangepickerController)

import FileinputController from "./fileinput_controller"
application.register("fileinput", FileinputController)

import FilteringController from "./filtering_controller"
application.register("filtering", FilteringController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SweetalertController from "./sweetalert_controller"
application.register("sweetalert", SweetalertController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TomSelectRemoteController from "./tom_select_remote_controller"
application.register("tom-select-remote", TomSelectRemoteController)

import UserToggleController from "./user_toggle_controller"
application.register("user-toggle", UserToggleController)

import VoiceInputController from "./voice_input_controller"
application.register("voice-input", VoiceInputController)

import ColorModeController from "./color_mode_controller"
application.register("color-mode", ColorModeController)
